/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dayjs } from 'dayjs';
import { Environment } from '../../../../environment';
import { Apiestoque } from '../../axiosestoque';
import { v4 as uuidv4 } from 'uuid';
import axios, { AxiosError } from 'axios';

type NullableDate = Date | null | undefined;

export interface IListagemTransferencias {
  idtransferencia: string;
  datalan: Date;
  portador: string;

  origem: string;
  destino: string;
  status: string;
}

export interface IitensTransferenciaDialog{
  iditens: string;
  idprod: string;
  idlocalizacao: string; 
  qtdsaida: number; 
  validade?: string | null;
  qtdentrada: number;
  preco: number;
  un: string;
  conversor: number;
  total: number;

  referencia: string;
  qtdestoque: number;
  filtro: string;
  descricao: string;
  reqvencimento: boolean; 
}

interface IgetTransferencia {
  iddestino: string;
  idorigem: string;
  datalan: Date;
  dataenvio?: NullableDate;
  datarecebimento?: NullableDate;
  portador: string;
  status: number;
  itens: IitensTransferenciaDialog[];
}

interface IDetalheSaida {
  iddestino: string;
  idorigem: string;
  datalan: Date;
  dataenvio?: NullableDate;
  datarecebimento?: NullableDate;
  portador: string;
  status: number;
}

interface IItensids{
  iditens: string;
}

type TotalCount = {
  data: IListagemTransferencias[];
  totalCount: number;
}

interface ErrorResponse {
  data: {
    errors: {
      [key: string]: string;
    };
  };
}

interface EstoqueQuantidade {
  idprod: string; 
  idlocalizacao: string; 
  vencimento: boolean; 
  validade: string | Dayjs | null | undefined;
}

interface Quantidade{
  quantidade: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, dataInicial = '', dataFinal='', tipo='', idlocalizacao=''): Promise<TotalCount | Error> => {
  try {
    
    const urlRelativa = `/transferenciaestoque?page=${page}&limit=${17}&tipo=${tipo}&inicial=${dataInicial}&final=${dataFinal}&origem=${idlocalizacao}`;
    const { data, headers } = await Apiestoque.get(urlRelativa);  
 
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 17),
      };
    }
 
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getById = async (id: string): Promise<IgetTransferencia | Error> => {
  try {

    const { data } = await Apiestoque.get(`/transferenciaestoque/${id}`);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (dados: IDetalheSaida, dadositens: IitensTransferenciaDialog[]): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const dadosExtraidos = dadositens.map(({ qtdestoque, referencia, descricao, reqvencimento, filtro, ...restoDoObjeto }) => ({ idoperacao: guuid, 
      tipo: 2, forma: 3, ...restoDoObjeto }));
    const dadosEntrada = {idtransferencia: guuid, datarecebimento: null, ...dados};
    
    const { data } = await Apiestoque.post<IDetalheSaida>('/transferenciaestoque',  [dadosEntrada, dadosExtraidos]);
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (typeof error === 'object' && error !== null && 'data' in error && 'errors' in (error as ErrorResponse).data) {
      const e = error as ErrorResponse;
      const errorMessages = Object.entries(e.data.errors)
        .map(([field, message]) => `${field}: ${message}`)
        .join('; ');
      return new Error(errorMessages);
    } else {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
          return new Error(errorMessage);
        } else if (axiosError.request) {
          return new Error('Nenhuma resposta do servidor');
        } else {
          return new Error(axiosError.message);
        }
      } else {
        return new Error('Erro inesperado');
      }
    }
  }
};

const estoqueQuantidade = async (dados: EstoqueQuantidade): Promise<Quantidade | Error> => {
  try {
    
    const { data } = await Apiestoque.post('/estoquequantidade', dados);  

    if (data) {
      return (data);
    }

    return new Error('Erro ao pesquisar quantidade do ítem selecionado.');
  } catch (error) {
    if (typeof error === 'object' && error !== null && 'data' in error && 'errors' in (error as ErrorResponse).data) {
      const e = error as ErrorResponse;
      const errorMessages = Object.entries(e.data.errors)
        .map(([field, message]) => `${field}: ${message}`)
        .join('; ');
      return new Error(errorMessages);
    } else {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
          return new Error(errorMessage);
        } else if (axiosError.request) {
          return new Error('Nenhuma resposta do servidor');
        } else {
          return new Error(axiosError.message);
        }
      } else {
        return new Error('Erro inesperado');
      }
    }
  }
};

const updateById = async (id: string, dados: IDetalheSaida, dadositens: IitensTransferenciaDialog[], iddeletados: IItensids[]): Promise<void | Error> => {
  try {

    const dadosExtraidos = dadositens.map(({ descricao, reqvencimento, filtro, referencia, ...restoDoObjeto }) => ({ idoperacao: id, ...restoDoObjeto }));
    //const { venda, ...dadosIDetalheSaida } = dados;
    const dadosEntrada = {idtransferencia: id, datarecebimento: null, ...dados};
    await Apiestoque.put(`/transferenciaestoque/${id}`, [dadosEntrada, dadosExtraidos, iddeletados]);

  } catch (error) {

    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Apiestoque.delete(`/transferenciaestoque/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const TransferenciaService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  estoqueQuantidade,
};